import { titleTextColor } from './constant';

const image = {
  altText: 'products',
  contentType: 'image/svg+xml',
  createdBy: 'admin',
  createdDate: '2021-04-27 10:00:00',
  deleted: false,
  fileName: 'unifyxp2/default/page404/404.svg',
  height: 81,
  modifiedBy: 'admin',
  modifiedDate: '2021-04-27 10:00:00',
  originalName: '404.svg',
  size: 1708,
  tags: [],
  url: 'https://resource2.unifyxp.com/unifyxp2/default/page404/404.svg',
  uuid: 'c0d7da8c-2b41-4e58-b5de-ecbd261c501c',
  valid: true,
  width: 81,
};

export default {
  pc: {
    contentSetting: {
      image,
      title: 'Page Not Found',
    },
    buttonText: {
      buttonText: 'Return To Homepage',
      buttonThemeUuid: null,
    },
    featuredProducts: {
      [titleTextColor]: null,
    },
  },
  tablet: {
    contentSetting: {
      image,
      title: 'Page Not Found',
    },
    buttonText: {
      buttonText: 'Return To Homepage',
      buttonThemeUuid: null,
    },
    featuredProducts: {
      [titleTextColor]: null,
    },
  },
  mobile: {
    contentSetting: {
      image,
      title: 'Page Not Found',
    },
    buttonText: {
      buttonText: 'Return To Homepage',
      buttonThemeUuid: null,
    },
    featuredProducts: {
      [titleTextColor]: null,
    },
  },
};
